import { CPS_CONTENT_TYPE_FIELD_TYPE, CpsContentTypeFieldType, CpsDocumentMetadataValue } from '@cs-cms/types';

export interface PreviewValueFormatters {
  formatDate: (value: Date) => string;
  formatDateTime: (value: Date) => string;
  formatBoolean: (value: boolean) => string;
}

function toDate(value: CpsDocumentMetadataValue): Date | undefined {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
  }

  return undefined;
}

export function formatPreviewFieldValue(
  value: CpsDocumentMetadataValue | null,
  fieldType: CpsContentTypeFieldType,
  formatters: PreviewValueFormatters
): string {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  if (fieldType === CPS_CONTENT_TYPE_FIELD_TYPE.BOOL) {
    if (typeof value !== 'boolean') {
      return '';
    }
    return formatters.formatBoolean(value);
  }

  if (fieldType === CPS_CONTENT_TYPE_FIELD_TYPE.DATE) {
    const date = toDate(value);
    return date ? formatters.formatDate(date) : '';
  }

  if (fieldType === CPS_CONTENT_TYPE_FIELD_TYPE.DATETIME) {
    const date = toDate(value);
    return date ? formatters.formatDateTime(date) : '';
  }

  if (Array.isArray(value)) {
    return value.join(', ');
  }

  return String(value);
}
